import { DynamicPropertyType } from 'types/DynamicPropertyType';

import type DynamicGroup from './Group';
import { DynamicProperty } from './Property';

export default class Text extends DynamicProperty<string> {
  type = DynamicPropertyType.TEXT;

  constructor(parent: DynamicGroup, name: string, value: string) {
    super(parent, name, value);
    // this.becomeObservable();
  }

  setDefault = () => {
    this.setInitialValue('Lorem Ipsum');
  };

  setUsingCSV = (value: string) => {
    this.set(value);
  };
}
